<template>
  <div class="d-flex justify-between mt-4 mr-4">
    <div class="w-100 " style="padding-left: 20px;"></div>

    <loadingComponent v-if="dialogPres == true" @closeDialog="dialogPres = $event" :dialogProps="dialogPres"
      :loadingProps="loadingPres" />

    <!-- Graph Dialog with Activator -->
    <v-dialog v-model="dialogGraph" width="750">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="ml-4 white--text"
          :color="$colors[0]"
          :disabled="isArrayEmptyRecursive(indexes)"
          v-bind="attrs"
          v-on="on"
        >
          Créer une présentation<v-icon size="20" class="ml-2">mdi-file-document-outline</v-icon>
        </v-btn>
      </template>

      <v-card class="d-flex flex-column" min-height="400">
        <v-card-title class="pb-0">
          Options de présentation
        </v-card-title>

        <v-card-text class="pt-4">
          <!-- Graph card with expand/collapse -->
          <v-card outlined class="mb-4">
            <div
              class="d-flex align-center justify-space-between px-4 py-3"
              style="cursor: pointer;"
              @click="graphExpanded = !graphExpanded"
            >
              <div class="d-flex align-center">
                <span class="font-weight-medium">Évolution du marché du gaz</span>
              </div>
              <div class="d-flex align-center">
                <v-switch
                  v-model="toggleCharts"
                  hide-details
                  dense
                  class="mt-0 pt-0 mr-2"
                  :label="toggleCharts ? 'Inclus' : 'Non inclus'"
                  @click.stop
                ></v-switch>
                <v-icon>{{ graphExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
              </div>
            </div>

            <v-expand-transition>
              <div v-show="graphExpanded">
                <v-divider></v-divider>
                <v-card-text>
                  <researchDate
                    class="pt-0 pr-0"
                    @updateCourbe="
                      updateCourbe(
                        charts[0].chartOptions.series,
                        charts[0].urlAPI,
                        $event.dateDebut,
                        $event.dateFin,
                        charts[0].items,
                        charts[0].chartOptions.categories,
                        charts[0].data
                      )
                    "
                  />
                  <div id="charts" ref="chartCapture">
                    <chart
                      v-if="chartReady"
                      :optionsChart="charts[0].chartOptions"
                      :seriesCharts="charts[0].chartOptions.series.value"
                      :updateChartsOptions="charts[0].updateChartsOptions"
                      styleProps="height:280px;"
                    />
                  </div>
                </v-card-text>
              </div>
            </v-expand-transition>
          </v-card>

          <!-- Abo switch (Gas only) -->
          <v-card outlined>
            <div class="d-flex align-center justify-space-between px-4 py-3">
              <span class="font-weight-medium">Abo inclus dans frais de distribution</span>
              <v-switch
                v-model="inclusAboGrdGrdf"
                hide-details
                dense
                class="mt-0 pt-0"
              ></v-switch>
            </div>
          </v-card>
        </v-card-text>

        <v-spacer></v-spacer>

        <v-divider></v-divider>

        <v-card-actions class="pa-4 d-flex flex-row justify-end">
          <v-btn
            color="error"
            text
            @click="dialogGraph = false"
          >
            Fermer
          </v-btn>

          <v-btn
            :color="$colors[0]"
            class="white--text ml-4"
            @click="captureAndCreatePres"
          >
            Générer présentation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- comment button associe un vendeur  -->
    <!-- <v-btn v-if="associe_vendeur" class="ml-4 white--text" :color="$colors[0]"
      :disabled="isArrayEmptyRecursive(indexes)" @click="toggleAssocie = true">
      Associe un Vendeur
    </v-btn> -->

    <!-- comment dialog associe un vendeur  -->
    <v-dialog v-model="toggleAssocie" width="750" persistent max-width="750">
      <v-card class="d-flex flex-column justify-end" min-height="300">
        <v-card-title>
          Associé un vendeur
          <v-spacer></v-spacer>
          <v-icon @click="toggleAssocie = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12" md="12">
                <v-select required outlined multiple v-model="vendeur"
                  :items="vendeurList.slice().sort((a, b) => a.userName.localeCompare(b.userName))"
                  label="Liste Vendeur" item-text="userName" item-value="id" return-object="false"></v-select>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field v-model="dateExpiration" label="Date d'expiration" outlined type="date"
                  :rules="[rules.required(`date obligatoire`)]"></v-text-field>
              </v-col>

              <v-col cols="12" md="12">
                <v-text-field v-model="commentaire" label="Commentaire" outlined
                  :rules="[rules.required(`veillez saisir un commentaire`)]"></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-btn color="primary" @click="sendVendorData" v-if="vendeur.length > 0">
                  Valider
                </v-btn>
                <v-btn color="#b8b8b8" disabled v-else> Valider </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import loadingComponent from "../../../components/ui/loading-component.vue";
import researchDate from "../../charts/components/research-date.vue";
import chart from "../../charts/components/chart.vue";
import axios from "axios";
import html2canvas from "html2canvas";

export default {
  name: "presentationGaz",
  components: {
    loadingComponent,
    researchDate,
    chart,
  },
  props: {
    infosCompteurPresentationProps: null,
    donnerDesFournisseur: [],
    fournisseurActuelle: null,
    indexes: [],
    numCompteur: null,
    donnerCompteur: [],
    societe: [],
    id_historique_cotation: null,
    associe_vendeur: false,
  },
  data() {
    return {
      dialogPres: false,
      loadingPres: false,
      toggleAssocie: false,
      dateExpiration: new Date().toISOString().split('T')[0],
      vendeur: "",
      commentaire: "",
      vendeurList: [],
      listOffreSelected: {},
      selectedCompteur: null,
      // Chart modal data
      dialogGraph: false,
      toggleCharts: true,
      graphExpanded: true,
      chartReady: false,
      chartScreenshot: null,
      inclusAboGrdGrdf: false,
      charts: [
        {
          idCapture: "capture-gaz",
          items: { value: [] },
          data: { value: null },
          updateChartsOptions: null,
          chartOptions: {
            colors: ["#000000", "#1E6CA4", "#c7c804", "#f8c954"],
            title: "Évolution du gaz",
            series: { value: [] },
            categories: { value: [] },
          },
          urlAPI: "getAllDataCourbeGaz/",
        },
      ],
      rules: {
        isPositiveNumb: (v) =>
          /^[0-9]\d*$/.test(v) ||
          "La valeur doit etre un entier strictement supérieur à 0",
        required(fieldName) {
          return (value) => !!value || `Veuillez saisir ${fieldName}`;
        },
      },
    };
  },
  async created() {
    await this.getListVendor();
    await this.loadInitialChartData();
  },
  methods: {
    async loadInitialChartData() {
      await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + this.charts[0].urlAPI,
        method: "POST",
        data: {
          year: 2022,
          dateDebut: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split("T")[0],
          dateFin: new Date().toISOString().split("T")[0],
        },
      })
        .then((res) => {
          const dataCharts = res.data.data;
          const newSeries = [];

          let allDates = new Set();
          Object.keys(dataCharts).forEach((key) => {
            const labels = dataCharts[key]["label"];
            labels.forEach(date => allDates.add(date));
          });

          const sortedAllDates = Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));

          Object.keys(dataCharts).forEach((key) => {
            const labels = dataCharts[key]["label"];
            const values = dataCharts[key]["data"];

            const dataMap = {};
            labels.forEach((label, index) => {
              dataMap[label] = values[index];
            });

            const alignedValues = sortedAllDates.map(date => {
              const value = dataMap[date];
              // Hide 0 values by converting to null
              if (value === undefined || value === null || value === 0) return null;
              return value;
            });

            newSeries.push({
              name: key,
              data: alignedValues,
            });
          });

          this.$set(this.charts[0].chartOptions.series, 'value', newSeries);
          this.$set(this.charts[0].chartOptions.categories, 'value', sortedAllDates);

          this.chartReady = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async updateCourbe(
      series,
      urlAPI,
      dateDebut,
      dateFin,
      itemsSeries,
      categories,
      dataSeries
    ) {
      await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + urlAPI,
        method: "POST",
        data: { year: 2022, dateDebut: dateDebut, dateFin: dateFin },
      })
        .then((res) => {
          const dataCharts = res.data.data;
          const newSeries = [];
          const newItems = [];

          let allDates = new Set();
          Object.keys(dataCharts).forEach((key) => {
            const labels = dataCharts[key]["label"];
            labels.forEach(date => allDates.add(date));
          });

          const sortedAllDates = Array.from(allDates).sort((a, b) => new Date(a) - new Date(b));

          Object.keys(dataCharts).forEach((key) => {
            const labels = dataCharts[key]["label"];
            const values = dataCharts[key]["data"];

            const dataMap = {};
            labels.forEach((label, index) => {
              dataMap[label] = values[index];
            });

            const alignedValues = sortedAllDates.map(date => dataMap[date] !== undefined ? dataMap[date] : null);

            newSeries.push({
              name: key,
              data: alignedValues,
            });
            newItems.push({
              categorie: key,
              today: dataCharts[key]["dataTable"][key]["jour"],
              week: dataCharts[key]["dataTable"][key]["semaine"],
              month: dataCharts[key]["dataTable"][key]["month"],
              year: dataCharts[key]["dataTable"][key]["years"],
            });
          });

          this.$set(series, 'value', newSeries);
          this.$set(categories, 'value', sortedAllDates);
          this.$set(itemsSeries, 'value', newItems);
          this.$set(dataSeries, 'value', dataCharts);

          this.charts[0].updateChartsOptions = {
            series: newSeries,
            xaxis: {
              type: "datetime",
              categories: sortedAllDates,
              tickPlacement: "on",
            },
          };
        })
        .catch((err) => {
          console.log(err);
        });
    },
    isArrayEmptyRecursive(arr) {
      if (!Array.isArray(arr)) {
        return false;
      } else {
        for (const element of arr) {
          if (element.length >= 1) {
            return false;
          }
        }
      }

      if (arr.length === 0) {
        return true;
      }

      return true;
    },
    async getListVendor() {
      await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "getAllVendeursProspecteurs/",
        method: "POST",
        data: {
          token: this.getToken("token"),
        },
      })
        .then((response) => {
          this.vendeurList = response.data.result;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    send_data() {
      let data = {};
      for (let i = 0; i < this.donnerDesFournisseur.length; i++) {
        if (this.indexes[i].length > 0) {
          data[this.donnerDesFournisseur[i]["NumCompteur"]] = [];
          for (let j = 0; j < this.indexes[i].length; j++) {
            let prixVert = this.donnerDesFournisseur[i]["resultat"]["result"][this.indexes[i][j]].prixVert

            let offer = {
              ...this.donnerDesFournisseur[i]["resultat"]["result"][this.indexes[i][j]],
              origineEnergieVerte: 'Europe',
              origine: 'Europe',
              isGreenEnergy: prixVert ? true : false,
              security_deposit: 0,
              consumption_commitment: 0,
              consumption_flexibility: 0,
              green_energy_percentage: 0,
              green_energy_price: prixVert || 0
            };
            if (j === 0) {
              offer.date_debut = this.date_debut;
            }
            data[this.donnerDesFournisseur[i]["NumCompteur"]].push(offer);
          }
        }
      }
      this.listOffreSelected = data;

      const compteurKeys = Object.keys(data);
      if (compteurKeys.length > 0) {
        this.selectedCompteur = compteurKeys[0];
      }

      return data;
    },
    async sendVendorData() {
      if (
        !(
          this.vendeur.length == 0 ||
          this.dateExpiration == "" ||
          this.commentaire == ""
        )
      ) {
        let data = {
          token: this.getToken("token"),
          list_allowed_compte: this.vendeur.map((item) => item.id),
          expiration_date: this.dateExpiration,
          id_historique_de_cotation: this.id_historique_cotation,
          commentaire: this.commentaire,
          cotationParCompteur: this.send_data(),
        };

        this.toggleAssocie = false;
        this.dialogPres = true;
        this.loadingPres = true;

        await axios({
          url:
            process.env.VUE_APP_URL_API_CLIENT +
            "ajouterHistoriqueDeCotationParCompteGaz/",
          method: "POST",
          data: data,
        })
          .then((response) => {
            if (response.data.result == true) {
              this.dialogPres = false;
              this.loadingPres = false;
            }

            this.vendeur = "";
            this.dateExpiration = "";
            this.commentaire = "";
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        alert("veillez remplir tous les champs");
      }
    },

    async captureAndCreatePres() {
      try {
        // Close modal and show loading immediately
        this.dialogGraph = false;
        this.dialogPres = true;
        this.loadingPres = true;

        // Capture the chart screenshot if toggle is on
        if (this.toggleCharts) {
          const chartElement = this.$refs.chartCapture;
          if (chartElement) {
            const canvas = await html2canvas(chartElement, {
              allowTaint: true,
              useCORS: true,
              scale: 3 // Capture at 3x resolution for better quality
            });
            this.chartScreenshot = canvas.toDataURL("image/png");
          }
        } else {
          this.chartScreenshot = null;
        }

        this.indexes = this.indexes.map(innerArray => innerArray.sort((a, b) => a - b));

        let societeData = this.donnerDesFournisseur[0]["resultat"]["dataSociete"];

        let allMetersData = [];

        const commonData = {
          vendeur: {
            email: "",
            name: "",
            tel: "",
          },
          client: {
            email: societeData.AdresseEmail,
            name: societeData.prenom + " " + societeData.nom,
            tel: societeData.numTele,
          },
          societeData: societeData,
          chartScreenshot: this.chartScreenshot,
          inclusAboGrdGrdf: this.inclusAboGrdGrdf,
        };

        for (let [k, fournisseur] of this.donnerDesFournisseur.entries()) {
          if (!this.indexes[k] || this.indexes[k].length === 0) {
            continue;
          }

          let typeCompteur = fournisseur["resultat"]["typeCompteur"];
          let numCompteur = fournisseur["resultat"]["numCompteur"];
          let donnerCompteur = fournisseur["resultat"]["donnerCompteur"];
          let dataEnedis = fournisseur["resultat"]["dataEnedis"];
          let nbrMonth = donnerCompteur["nbrMonth"];
          const monthsBetween = (new Date(this.date_fin).getFullYear() - new Date(this.date_debut).getFullYear()) * 12 + (new Date(this.date_fin).getMonth() - new Date(this.date_debut).getMonth());

          let listDesOffre = fournisseur["resultat"]["result"].filter(
            (item, ind) => this.indexes[k]?.includes(ind)
          );

          let offresNonActuelleExist = listDesOffre.some(of => of.typeFournisseur != "Actuelle");

          if (offresNonActuelleExist) {
            let meterData = {
              numCompteur,
              typeCompteur,
              dates: {
                date_debut: this.date_debut,
                date_fin: this.date_fin,
                mois: monthsBetween
              },
              listDesOffre,
              dataCompteur: donnerCompteur,
              dataEnedis,
              nbrMonth
            };

            allMetersData.push(meterData);
          }
        }

        if (allMetersData.length > 0) {
          try {
            // Create FormData for multipart upload
            const formData = new FormData();

            // Add JSON data
            const jsonData = {
              ...commonData,
              meters: allMetersData,
            };
            delete jsonData.chartScreenshot; // Remove from JSON, will send as file
            formData.append('data', JSON.stringify(jsonData));

            // Add chart image if exists
            if (this.chartScreenshot) {
              const base64Data = this.chartScreenshot.split(',')[1];
              const byteCharacters = atob(base64Data);
              const byteNumbers = new Array(byteCharacters.length);
              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              const imageBlob = new Blob([byteArray], { type: 'image/png' });
              formData.append('chartImage', imageBlob, 'chart.png');
            }

            const response = await axios({
              url: process.env.VUE_APP_URL_EDITION_CONTRACT_V2 + "presentation/presentation-elly-energie-gaz",
              method: 'POST',
              data: formData,
              headers: {
                'Content-Type': 'multipart/form-data',
              },
              responseType: 'blob',
              timeout: 60000
            });

            const blob = new Blob([response.data], { type: "application/pdf" });

            var today = new Date().toISOString().split('T')[0];

            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = "Presentation_" +
              this.donnerDesFournisseur[0]["resultat"]["dataSociete"]["siret"] +
              "_" +
              today +
              ".pdf";

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href);
          } catch (error) {
            console.error('Error generating presentation:', error);
            alert("Erreur lors de la génération de la présentation. Veuillez réessayer.");
          }
        } else {
          alert("Aucune offre sélectionnée pour générer la présentation.");
        }
      } catch (error) {
        console.error('Error in createPres:', error);
      } finally {
        this.loadingPres = false;
        this.dialogPres = false;
      }
    },
  },
  watch: {
    indexes: {
      handler(newValue) {
        this.send_data();
      },
      deep: true,
    },
  },
};
</script>
